import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../store/RootState";
import commonNetwork from "../../../common/api/commonNetwork";
import { Button, ProgressLoader } from "../Elements";
import MaterailTable, { HeadCellType } from "../Elements/MaterialTable";
import { SabeeappBookingListProps } from "../../../common/types";
import StatusBox from "../Elements/StatusBox";
import { FaEllipsisV } from "react-icons/fa";
import { Alert, ListItemIcon, Menu, MenuItem, } from "@mui/material";
import { CreditCard, Send } from "@mui/icons-material";
import CreatePaymentLinkModal, { CreatePaymentLinkModalRefProps } from "./CreatePaymentLinkModal";
import ConfirmationModal from "../ConfirmationModal";
import { toast } from "react-toastify";
import { muiMenuStyles } from '../../../constants/muiMenuStyles';

const BookingTable = () => {
    const classes = muiMenuStyles();



    const reportTableRef = useRef<any>();
    const confirmModalRef = useRef<any>();
    const createPaymentLinkModalRef = useRef<CreatePaymentLinkModalRefProps>(null);
    const { bookingResult, isFetching, errorMessage, isError } = useSelector((state: RootStateType) => state.sabeeAppBookingList);
    const [excelLoading, setExcelLoading] = useState(false);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [progressLoading, setProgressLoading] = useState(false);
    const isopenMenu = Boolean(anchorEl);
    const [dropdownAllValues, setDropdownAllValues] = useState<SabeeappBookingListProps>();

    const exportToExcelClick = async () => {

        const allData = bookingResult.data.reservations || [];

        var selecteds = reportTableRef.current.getSelectedRows();
        if (selecteds.length > 0) {
            setExcelLoading(true);
            var excelList: any = [];
            var columnWidth = [];
            var withoutExcel = headCells.filter(function (el) {
                return el.exceptToExcel !== true
            });
            for (let i = 0; i < selecteds.length; i++) {
                excelList.push({});
                const element = selecteds[i];
                let itemindex = allData.findIndex(w => w.reservation_code === element);
                let item: any = allData[itemindex];

                for (let j = 0; j < withoutExcel.length; j++) {
                    const element2 = withoutExcel[j];
                    var value = item[element2.id];

                    if (element2.id === "status") {

                        value = item.status === true ? "Aktif" : "Pasif";
                    }

                    if (withoutExcel.length >= columnWidth.length) {
                        columnWidth.push({
                            width: element2.colWidth
                        });
                    }



                    excelList[i][element2.label || ""] = value;
                }
            }

            const datestr = "e-Tahsilat - Zamanlanmış Aktarım Kayıtları";

            var result = await commonNetwork.post("/Export/exportCustomerToExcel", excelList, true);

            setExcelLoading(false);

            if (result.data) {
                const href = URL.createObjectURL(result.data);


                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', datestr + ".xlsx");
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                reportTableRef.current.clearSelected();
            }
        }
    }


    const handleClickMenu = (event: any, row: SabeeappBookingListProps) => {

        setDropdownAllValues(row);
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const onClickCreateLink = () => {

        ///@ts-ignore
        createPaymentLinkModalRef.current?.openModal(dropdownAllValues);
        handleClose();
    }

    const onSubmitPaymentClick = () => {

        setAnchorEl(null);

        confirmModalRef.current.showConfirm({
            title: "Ödeme Kaydı Aktarılacak",
            contentText: dropdownAllValues?.reservation_code + " Rezervasyon koduna ait ödeme kaydı Sabeeapp'e aktarılacak. Onaylıyor musunuz?",
            confirmText: "Aktar",
            cancelText: "İptal",
            confirmCallBack: () => onSubmitPaymentConfirm()
        });

    }
    const onSubmitPaymentConfirm = async () => {

        setProgressLoading(true);

        const params = dropdownAllValues;
        const {data, errorMessage, isSuccess} = await commonNetwork.post("sabeeapp/submit-payment", params);

        if (isSuccess) {
            toast.success("Rezervasyon başarılı bir şekilde aktarılmıştır.");
        } else {
            toast.error(errorMessage ||"Rezervasyon aktarılırken hata meydana geldi. Lütfen tekrar deneyiniz.");
        }
        setProgressLoading(false);
    }


    const bottomElement =
        <div className="mt-5 mt-4 flex justify-end space-x-2">
            <Button
                color="primary"
                hover="primary"
                size="xs"
                callback={() => exportToExcelClick()}
                loading={excelLoading}
            >
                Excel'e Aktar
            </Button>
        </div>


    const DropdownMenu = () => {
        return (
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={isopenMenu}
                onClose={handleClose}
                classes={{
                    paper: classes.paper,
                }}

            >
                <MenuItem onClick={onClickCreateLink} disabled={progressLoading}>
                    <ListItemIcon>
                        <CreditCard fontSize="small" />
                    </ListItemIcon>
                    Ödeme Al
                </MenuItem>
                {dropdownAllValues?.linkStatus == "successPayment" && (
                    <MenuItem onClick={onSubmitPaymentClick} disabled={progressLoading}>
                        <ListItemIcon>
                            <Send fontSize="small" />
                        </ListItemIcon>
                        Kaydı Aktar
                    </MenuItem>
                )}
            </Menu>
        );
    }

    function maskName(firstName?: string, lastName?: string) {
        function maskString(str?: string) {
            if (!str || str.length < 2) return str; // Return original string if it's too short to mask
            return str[0] + '*'.repeat(str.length - 1);
        }

        const maskedFirstName = maskString(firstName);
        const maskedLastName = maskString(lastName);

        return `${maskedFirstName} ${maskedLastName}`;
    }

    const headCells: Array<HeadCellType> = [
        {
            id: 'operations',
            numeric: false,
            label: 'İşlemler',
            exceptToExcel: true,
            className: "max-w-[50px]",
            isRender: true,
            renderRow: (row: SabeeappBookingListProps) => {

                return (
                    <div className="flex flex-row justify-around items-center">

                        <a id="basic-button"
                            aria-controls={isopenMenu ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={isopenMenu ? 'true' : undefined}
                            className="cursor-pointer"
                            onClick={(event) => handleClickMenu(event, row)}>
                            <FaEllipsisV
                                className="block sm:block h-3 w-3 font-light	ml-1"
                                aria-hidden="true"
                            />
                        </a>
                        <DropdownMenu />

                    </div>
                );

            }
        },
        {
            id: 'id',
            numeric: false,
            label: 'ID',
            isprimary: true,
            className: "min-w-[50px]",
            colWidth: 10, // For excel
            hide: true,
            exceptToExcel: true
        },
        {
            id: 'reservation_code',
            numeric: true,
            label: 'Rez. Kod',
            className: "w-[120px]",
            maxLength: 15,
            colWidth: 20, // For excel
        },
        {
            id: 'customerName',
            numeric: false,
            label: 'Müşteri Adı',
            className: "min-w-[100px]",
            colWidth: 20, // For Excel
            isRender: true,
            renderRow: (row: SabeeappBookingListProps) => (
                <span>{maskName(row.customer?.first_name, row.customer?.last_name)}</span>
            )
        },
        {
            id: 'checkin_date',
            numeric: false,
            label: 'C/I Tarihi',
            colWidth: 20, // For excel
            className: "w-[150px]",
            isRender: true,
            renderRow: (row: SabeeappBookingListProps) => {

                let date = row.checkin_date.split("-");
                const parsedDate = date[2] + "." + date[1] + "." + date[0];
                return (
                    <span>{parsedDate}</span>
                )
            }
        },
        {
            id: 'rooom_price',
            numeric: true,
            isMoney: true,
            label: 'Konaklama Tutarı',
            className: "w-[180px]",
            currencySymbolCol: "currency",
            colWidth: 30, // For excel
        },
        {
            id: 'paid',
            numeric: true,
            isMoney: true,
            label: 'Ödenen Tutar',
            currencySymbolCol: "currency",
            className: "w-[180px]",
            colWidth: 30, // For excel
        },
        {
            id: 'linkStatus',
            forcealign: "center",
            label: 'Link Durumu',
            className: "w-[200px]",
            colWidth: 30, // For excel
            isRender: true,
            renderRow: (row: SabeeappBookingListProps) => {

                const linkStatus = row.linkStatus;

                let statusColor: any = "primary";
                let contentTexgt = ""
                switch (linkStatus) {
                    case "emptyStatus":
                    case "waitPayment":
                        return null;
                    case "errorPayment":
                        statusColor = "error";
                        contentTexgt = "Ödeme Başarısız"
                        break;
                    case "successPayment":
                        statusColor = "success";
                        contentTexgt = "Ödeme Başarılı"
                        break;
                    case "waitLinkOpen":
                        statusColor = "warning";
                        contentTexgt = row.linkSendType == 4 ? "Link Oluşturuldu" : "Link Gönderildi"
                        break;
                    default:
                        return null;
                }
                const boxWidth = "w-[115px]";
                return (
                    <StatusBox statusType={statusColor} content={contentTexgt} className={boxWidth} />
                )
            }
        },
    ];

    let errorMsg = [errorMessage];
    let isErrorSabeeRequest = false;
    if (bookingResult && bookingResult.success != undefined && bookingResult.success == false) {
        errorMsg = bookingResult.errors.map(u => u.ret_msg)
        isErrorSabeeRequest = true;
    }

    const progressLoader = () => {
        if (progressLoading) {
            return (

                <ProgressLoader />
            );
        }
    }

    return (
        <div className="w-full">
            {progressLoader()}
            <ConfirmationModal ref={confirmModalRef}></ConfirmationModal>
            <CreatePaymentLinkModal ref={createPaymentLinkModalRef} />
            {!isFetching && (isErrorSabeeRequest && errorMsg?.length > 0) ? (

                <div className="flex justify-center mt-6 items-center w-full  px-4 ">
                    <Alert color="error" severity="error" className="flex items-center">{errorMsg.map((item) => (
                        <div key={item} className="mt-2">
                            {item}
                        </div>
                    ))}</Alert>
                </div>
            ) : (
                <MaterailTable ref={reportTableRef} headerCells={headCells}
                    tableData={bookingResult?.data?.reservations || []}
                    isRowSelect={true} isLoading={isFetching} initialPageSize={25}
                    bottomElement={bottomElement}
                    emptyMessage={isFetching === false ? "Verilen kritere uygun kayıt bulunamamıştır" : ""}
                ></MaterailTable>
            )}



        </div>
    );
}
export default BookingTable;